import {
  IAirlineContentDTo,
  IAirlineInfo,
  IAirlineInfoDto,
  IAirlineInfoResponse,
  IAirlineRouteDto,
  IAirportLocalizationDto,
  IContentSectionDto,
  IFaqDto,
  IFleetCompositionDto,
  IMostPopularDestinationDtos,
} from '../../models/airlineInfo.models';

export const defaultAirlineInfoDto: IAirlineInfoDto = {
  airlineIatacode: '',
  language: '',
  airlineName: '',
  headquarters: '',
  parentCompany: '',
  contactInformation: null,
  aboutAirline: null,
};

export const defaultAirlineRouteDto: IAirlineRouteDto = {
  originCode: '',
  destinationCode: '',
  originCity: '',
  destinationCity: '',
  language: '',
};

export const defaultFleetCompositionDto: IFleetCompositionDto = {
  aircraftModel: '',
  aircraftType: '',
};

export const defaultContentSectionDto: IContentSectionDto = {
  language: '',
  sectionTitle: '',
  content: '',
  category: '',
  sectionOrder: 0,
};

export const defaultAirportLocalizationDto: IAirportLocalizationDto = {
  airportCode: '',
  languageCode: '',
  airportName: '',
};

export const defaultFaqDto: IFaqDto = {
  airlineIatacode: '',
  language: '',
  question: '',
  answer: '',
  priority: 0,
};

export const defaultmostPopularDestinationDtos: IMostPopularDestinationDtos = {
  destinationAirportCode: '',
  destinationCity: '',
  language: '',
};
export const defaultAirlineContentDto: IAirlineContentDTo = {
  airlineIatacode: '',
  contentType: '',
  slug: '',
  airlineContentDetailDto: [],
};
export const defaultAirlineInfo: IAirlineInfo = {
  iatacode: '',
  icaocode: '',
  yearOfEstablishment: 0,
  numberOfDestinations: 0,
  airlineImage: '',
  airlineLogo: '',
  airlineLogoWithName: '',
  mainOperationalAirportCode: '',
  airlineInfoDtos: [defaultAirlineInfoDto],
  airlineRouteDtos: [defaultAirlineRouteDto],
  fleetCompositionDtos: [defaultFleetCompositionDto],
  contentSectionDtos: [defaultContentSectionDto],
  airportLocalizationDtos: [defaultAirportLocalizationDto],
  faqDtos: [defaultFaqDto],
  mostPopularDestinationDtos: [defaultmostPopularDestinationDtos],
  airlineContentDto: defaultAirlineContentDto,
};

export const defaultAirlineInfoResponse: IAirlineInfoResponse = {
  status: 0,
  message: '',
  code: '',
  returnObject: defaultAirlineInfo,
};
